<template>
    <div class="page">
        <box>
            <el-form label-position="right" label-width="100px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道编号" class="EL-Form-Item">
                        <el-select v-model="mainSearch.whCode" placeholder="请选择" filterable clearable="clearable" @change="getTableData">
                            <el-option v-for="item in warehouseList" :key="item.whId" :label="item.whCode + '-' + item.whName" :value="item.whCode"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.matCode" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="操作编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.pmCode" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="5" :xl="5">
                    <el-form-item label="生产工单" class="EL-Form-Item">
                        <el-input v-model="mainSearch.opCode" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="配送状态" class="EL-Form-Item">
                        <el-select v-model="mainSearch.distrType">
                            <el-option label="默认(待配送、配送中)" value="10,20" />
                            <el-option label="待配送" value="10" />
                            <el-option label="配送中" value="20" />
                            <el-option label="已配送" value="30" />
                            <el-option label="关闭" value="40" />
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="saveSearch()">查询</el-button>
                        <el-button class="btn-t-delete" @click="resetMain">重置</el-button>
                    </el-form-item>
                </el-col>

                <el-col :lg="5" :xl="5">
                    <el-form-item label="配送方式" class="EL-Form-Item">
                        <el-select v-model="mainSearch.distrWay" clearable>
                            <el-option label="AGV配送" value="10" />
                            <el-option label="人工配送" value="20" />
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :lg="5" :xl="5">
                    <el-form-item label="箱号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.boxBarCode" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="9" :xl="9">
                    <el-form-item label="日期范围" class="EL-Form-Item">
                        <el-date-picker style="width: 350px" v-model="mainSearch.date" value-format="yyyy-MM-dd HH:mm" type="datetimerange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form>
        </box>
        <box fill>
            <plabel text="物料配送">
                <el-button v-authority="'BACK_MENU3_M4_B1'" class="btn-t-edit" @click="peopleDistribution()">
                    人工配送
                </el-button>
                 <el-button v-authority="'BACK_MENU3_M4_B2'" class="btn-t-edit" @click="openPersonDistrShow()">
                    人工配送完成
                </el-button>
                <el-button v-authority="'BACK_MENU3_M4_B3'" class="btn-t-edit" @click="openDialog()">
                    AGV配送
                </el-button>
                <el-button v-authority="'BACK_MENU3_M4_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <h-table :headerCellStyle="mainData.headerCellStyle" style="flex: 1" @pageChange="getTableData" :data="mainData.data" pagination :nowPage.sync="mainData.nowPage" :pageSize.sync="mainData.pageSize" :total.sync="mainData.total" @selectionChange="selectAllMain">
                <el-table-column type="selection" align="center" :selectable="checkboxMain">
                </el-table-column>
                <el-table-column label="通道编号" align="center" prop="whCode" min-width="100">
                    <template slot-scope="scope">
                        {{scope.row.whCode}}
                        <span v-if="scope.row.whCode!=scope.row.whCodeP">(叫料通道:{{scope.row.whCodeP}})</span>
                    </template>
                </el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode" min-width="100">
                </el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName" min-width="120">
                </el-table-column>
                <el-table-column label="物料数量" align="center" prop="matQuan">
                </el-table-column>
                <el-table-column label="实际库位" align="center" prop="lcCodeReal">
                    <template slot-scope="scope">
                        <span v-if="scope.row.distrType != '30'">{{scope.row.lcCodeReal}}</span>
                        <span v-else>RET{{scope.row.whCode}}</span>
                    </template>    
                </el-table-column>
                <el-table-column label="包装箱号" align="center" prop="boxBarcode" min-width="100">
                </el-table-column>
                <el-table-column label="操作编号" align="center" prop="operaCode" min-width="110">
                </el-table-column>
                <el-table-column label="生产工单" align="center" prop="opCode" min-width="110">
                </el-table-column>
                <el-table-column label="需求类型" align="center" prop="operaType">
                    <template slot-scope="scope">
                        <span v-if="scope.row.operaType == '10'">生产叫料</span>
                        <span v-if="scope.row.operaType == '20'">间材叫料</span>
                        <span v-if="scope.row.operaType == '30'">采购退货</span>
                        <span v-if="scope.row.operaType == '40'">移库</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态" align="center" prop="distrType">
                    <template slot-scope="scope">
                        <span v-if="scope.row.distrType == '10'">待配送</span>
                        <span v-if="scope.row.distrType == '20'">配送中</span>
                        <span v-if="scope.row.distrType == '30'">配送完成</span>
                        <!-- <span v-if="!scope.row.distrType">待检配</span> -->
                    </template>
                </el-table-column>
                <el-table-column label="配送人" align="center" prop="userName">
                </el-table-column>

                <el-table-column label="配送方式" align="center" prop="distrWay">
                    <template slot-scope="scope">
                        <div v-if="scope.row.distrWay == '10'">AGV配送</div>
                        <div v-if="scope.row.distrWay == '20'">人工配送</div>
                    </template>
                </el-table-column>

                <el-table-column label="创建时间" align="center" prop="createTime" min-width="130">
                </el-table-column>

                <el-table-column label="接单时间" align="center" prop="receiveTime" min-width="130">
                </el-table-column>
                <el-table-column label="拣配完成" align="center" prop="pickTime" min-width="130">
                </el-table-column>
                <el-table-column label="配送开始时间" align="center" prop="distributionStartTime" min-width="130">
                </el-table-column>
                <el-table-column label="配送结束时间" align="center" prop="distributionEndTime" min-width="130">
                </el-table-column>
                <el-table-column label="更新时间" align="center" prop="updateTime" min-width="130">
                </el-table-column>
            </h-table>
        </box>
        <el-dialog title="AGV配送" :visible.sync="dialogShow" class="fromDialog" :close-on-click-modal="false" :show-close="false" :style="$popups.popups(0.8,0.90)">
            <div style="overflow: hidden; padding-bottom: 10px">
                <el-form label-position="right" label-width="80px">
                    <el-col :lg="5" :xl="5">
                        <!-- <el-form-item label="库位">
                            <el-input v-model="agvInfo.laCode" placeholder="请输入"></el-input>
                        </el-form-item> -->
                        <el-form-item label="库位" class="EL-Form-Item">
                            <el-select v-model="agvInfo.laCode" placeholder="请选择" filterable>
                                <el-option v-for="(item, index) in sysPointRouterList" :key="index" :label="item.prCode" :value="item.prCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <h-table :style="$popups.harvestRecordStyle(0.63,0.02)" :headerCellStyle="mainData.headerCellStyle" :data="checkListMain">
                <el-table-column label="生产叫料编号" align="center" prop="operaCode">
                </el-table-column>
                <el-table-column label="生产工单编号" align="center" prop="opCode">
                </el-table-column>
                <el-table-column label="需求类型" align="center" prop="operaType">
                    <template slot-scope="scope">
                        <span v-if="scope.row.operaType == '10'">生产叫料</span>
                        <span v-if="scope.row.operaType == '20'">间材叫料</span>
                        <span v-if="scope.row.operaType == '30'">采购退货</span>
                        <span v-if="scope.row.operaType == '40'">移库</span>
                    </template>
                </el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode">
                </el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName">
                </el-table-column>
                <el-table-column label="创建时间" align="center" prop="createTime">
                </el-table-column>
                <el-table-column label="更新时间" align="center" prop="updateTime">
                </el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closeDailog" type="info" class="btn-t-info">关 闭</el-button>
                <el-button :loading="agvDistributions" @click="agvDistribution" class="btn-t-edit">确 认</el-button>
            </div>
        </el-dialog>

        <el-dialog title="人工配送完成" :visible.sync="personDistrShow" class="minInfoDialog" :close-on-click-modal="false" :show-close="false">
            <div style="overflow: hidden; padding-bottom: 10px">
                <el-form label-position="right" label-width="80px">
                    <el-form-item label="库位编号" prop="lcCode" class="EL-Form-Item">
                        <el-select v-model="lcCode" clearable="clearable" filterable placeholder="请选择">

                            <el-option v-for="(item, index) in sysLineRouterList" :key="index" :value="item.lrRealCode" :label="item.lrRealCode"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="personDistrClose()" type="info" class="btn-t-info">关 闭</el-button>
                <el-button @click="personPickComplete()" class="btn-t-edit">确 认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "MaterialDistributionnew",
        data() {
            return {
                mainData: {
                    data: [],
                    nowPage: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                // 筛选条件
                mainSearch: {
                    fcCode: localStorage.getItem("fcCode") || "",
                    person: localStorage.getItem("user"),
                    whCode: localStorage.getItem("whCode") || "", //通道编号
                    pmCode: "", //	生产叫料编号
                    opCode: "", //	生产工单编号
                    matCode: "", //	物料编号
                    distrType: "10,20",
                    distrWay:"",
                    boxBarCode: "",
                    date: [],
                },
                whCodeId: "",
                warehouseList: [],
                //多选
                checkListMain: [],

                //配送单
                agvInfo: {
                    pmIds: "",
                    laCode: "", //库位
                    whCode: "", //通道
                },
                dialogShow: false,

                downloadLoading: false, //下载中
                agvDistributions: false,

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注

                //agv搬运产线点位
                sysLineRouterList: [],
                //agv搬运备料区点位
                sysPointRouterList: [],

                personDistrShow: false, //人工配送完成
                lcCode: '', //产线库位
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.date[0]) {
                            return time.getTime() < new Date(_this.mainSearch.date[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.date[1]) {
                            return time.getTime() > new Date(_this.mainSearch.date[1]);
                        }
                    }
                }
            },
        },
        watch: {
            mainSearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.mainData.nowPage = 1;
                        this.getTableData(newVal);
                    }, 1000);
                },
                deep: true,
            },
        },

        methods: {
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy);
                window.lazy = window.setTimeout(() => {
                    this.mainData.nowPage = 1;
                    this.getTableData();
                }, 1000);
            },
            /**
             * 打开人工搬运窗口
             */
            openPersonDistrShow(){
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "请至少选择一个物料人工配送中的记录！",
                        type: "warning",
                    });
                    return;
                }else{
                    var whCode = this.checkListMain[0].whCode;
                    var flag = false;
                    var distrTypeFlag = false;
                    this.checkListMain.forEach((item)=>{
                        if(whCode !== item.whCode){
                            flag = true;
                        }
                        if (item.distrType!=='20') {
                            distrTypeFlag = true;
                        }
                    })
                    if (distrTypeFlag) {
                        this.$message({
                            message: "请选择人工配送中的内容进行人工确认完成操作",
                            type: "warning",
                        });
                        return;
                    }
                    if (flag) {
                        this.$message({
                            message: "请选择通道相同的物料人工配送进行人工确认完成操作！",
                            type: "warning",
                        });
                        return;
                    }else{
                        if(whCode == "54"){
                            this.getLcCodeAllByWhCode("");
                        }else{
                            this.getLcCodeAllByWhCode(whCode);
                        }
                        this.personDistrShow = true;
                    }    
                }
            },
            getTableData() {
                this.$http
                    .request({
                        url: "/api/stockPickDetail/getStockPickDetailData",
                        method: "GET",
                        params: {
                            pageNum: this.mainData.nowPage, //	页号
                            pageSize: this.mainData.pageSize, //	页大小
                            whCode: this.mainSearch.whCode,
                            fcCode: this.mainSearch.fcCode,
                            // person: this.mainSearch.person || null,
                            distrType: this.mainSearch.distrType || null,
                            distrWay: this.mainSearch.distrWay || null,
                            operaCode: this.mainSearch.pmCode || null, //	生产叫料编号
                            opCode: this.mainSearch.opCode || null, //	生产工单编号
                            matCode: this.mainSearch.matCode || null, //	物料编号
                            boxBarCode: this.mainSearch.boxBarCode || null, //箱号
                            beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null, //	开始时间
                            endTime: this.mainSearch.date ? this.mainSearch.date[1] : null, //	结束时间
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.mainData.data = res.data.list;
                            this.mainData.total = res.data.total;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },

            //关闭弹框
            personDistrClose() {
                this.personDistrShow = false;
                this.lcCode = "";
            },

            /**
             * 通道列表
             */
            getWarehouse() {
                this.$http
                    .request({
                        url: "/api/warehouse/getWarehouse",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            whCode: "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.warehouseList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            /**
             * 禁选
             */
            checkboxMain(row, rowIndex) {
                // if (row.distrType == "10") {
                //     return true; // 不禁用
                // } else {
                //     return false; // 禁用
                // }
                return true;
            },
            /**
             * 全选
             */
            selectAllMain(val) {
                this.checkListMain = val;
            },

            /**
             * 重置
             */
            resetMain() {
                this.mainSearch = {
                    fcCode: localStorage.getItem("fcCode") || "",
                    person: localStorage.getItem("user"),
                    whCode: "", //通道编号
                    pmCode: "", // 生产叫料编号
                    opCode: "", // 生产工单编号
                    matCode: "", // 物料编号
                    distrType: "10,20",
                    distrWay: "",
                    date: [],
                };
            },

            /**
             * 获取可用的备料区库位编号
             */
            getSysPointRouterMatSpare() {
                this.$http
                    .request({
                        url: "/api/sysPointRouter/getSysPointRouterMatSpare",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            //whCode: this.checkListMain[0].whCode || null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.sysPointRouterList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            /**
             * 人工配送
             */
            peopleDistribution() {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "请选择生产叫料",
                        type: "warning",
                    });
                    return;
                }
                const res = this.checkListMain.every(e => {
                    if (e.operaType == "30") {
                        this.$message({
                            message: "采购退货类型不需要配送",
                            type: "warning",
                        });
                        return false;
                    } else {
                        if(e.distrType != '10'){
                            this.$message({
                                message: "不是待配送状态，不可再配送",
                                type: "warning",
                            });
                            return false;
                        }
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }
                this.$confirm("是否确认人工配送?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        let pmIds = "";
                        this.checkListMain.forEach((element) => {
                                pmIds = pmIds + element.spdId + ",";
                            }),
                            this.$http
                            .request({
                                url: "/api/pick/insertStockProductShip",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    spdIds: pmIds.slice(0, pmIds.length - 1),
                                    fcCode: localStorage.getItem("fcCode") || "",
                                    whCode: localStorage.getItem("whCode") || "",
                                    laCode: null,
                                    distrType: "20",
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "stockProduceMat：生产叫料确认人工配送成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "stockProduceMat：生产叫料确认人工配送失败";
                                }
                                this.logContent = "pmIds：" + pmIds + "，personNumber: " + localStorage.getItem("empNumber")  + "，person: " + localStorage.getItem("user")
                                this.systemLog();
                                this.getTableData();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "error",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },

            /**
             * 人工配送完成
             */
            personPickComplete() {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "请选择配送中的记录",
                        type: "warning",
                    });
                    return;
                }

                if (this.lcCode === null || this.lcCode === "") {
                    this.$message({
                        message: "请选择配送的站点",
                        type: "warning",
                    });
                    return;
                }
                for (var index in this.checkListMain) {
                    if (this.checkListMain[index].operaType == "30") {
                        this.$message({
                            message: "采购退货类型不需要配送",
                            type: "warning",
                        });
                        return;
                    }
                    if (this.checkListMain[index].distrWay != '20') {
                        this.$message({
                            message: "请选择人工配送记录",
                            type: "warning",
                        });
                        return;
                    }
                    if (this.checkListMain[index].distrType != '20') {
                        this.$message({
                            message: "请选择配送中的记录",
                            type: "warning",
                        });
                        return;
                    }
                }

                this.$confirm("确认放入此位置吗？", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        let pmIds = "";
                        this.checkListMain.forEach((element) => {
                            if (pmIds == "") {
                                pmIds = element.spdId;
                            } else {
                                pmIds += "," + element.spdId;
                            }
                        })
                        this.$http
                            .request({
                                url: "/api/pick/personPickComplete",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    spdIds: pmIds,
                                    lrCode: this.lcCode,
                                    personNumber: localStorage.getItem("empNumber") || null,
                                    person: localStorage.getItem("user") || "",
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "stockProduceMat：生产叫料确认人工配送成功";
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "stockProduceMat：生产叫料确认人工配送失败";
                                }
                                this.logContent = "pmIds：" + pmIds + "lrCode: " + this.lcCode + "，personNumber: " + localStorage.getItem("empNumber")  + "，person: " + localStorage.getItem("user")
                                this.systemLog();
                                this.lcCode = "";
                                this.personDistrShow = false;
                                this.getTableData();
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "error",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },

            /**
             * 回显AGV配送数据
             */
            openDialog() {
                if (this.checkListMain.length == 0) {
                    this.$message({
                        message: "请选择生产叫料",
                        type: "warning",
                    });
                    return;
                }
                const res = this.checkListMain.every(e => {
                    if (e.operaType == "30") {
                        this.$message({
                            message: "采购退货类型不需要配送",
                            type: "warning",
                        });
                        return false;
                    } else {
                        return true;
                    }
                })
                if (res == false) {
                    return false;
                }
                let currentWh = "";
                for (let i = 0; i < this.checkListMain.length; i++) {
                    this.agvInfo.pmIds = this.agvInfo.pmIds + this.checkListMain[i].spdId + ",";
                    if (currentWh == "") {
                        currentWh = this.checkListMain[i].whCode;
                    }
                    if (currentWh != "" && currentWh != this.checkListMain[i].whCode) {
                        this.$message({
                            message: "请选择同一个通道的物料",
                            type: "warning",
                        });
                        currentWh = "";
                        return;
                    }
                    
                    if (this.checkListMain[i].distrType != "10") {
                        this.$message({
                            message: "请选择未配送的数据",
                            type: "warning",
                        });
                        return;
                    }
                    
                    if (this.checkListMain[i].distrWay == "20") {
                        this.$message({
                            message: "人工配送中，请选择其他数据",
                            type: "warning",
                        });
                        return;
                    }
                }
                this.agvInfo.whCode = currentWh;
                
                this.getSysPointRouterMatSpare();
                this.dialogShow = true;
            },
            closeDailog() {
                this.agvInfo.pmIds = "";
                this.agvInfo.laCode = "";
                this.dialogShow = false;
                this.getTableData();
            },

            /**
             * AVG配送
             */
            agvDistribution() {
                if (this.agvInfo.laCode == "") {
                    this.$message({
                        message: "请选择库位",
                        type: "warning",
                    });
                    return;
                }
                this.$confirm("是否确认AGV配送?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.agvDistributions = true;
                        this.$http
                            .request({
                                url: "/api/pick/insertStockProductShip",
                                method: "POST",
                                showLoading: true,
                                params: {
                                    spdIds: this.agvInfo.pmIds.slice(0, this.agvInfo.pmIds.length - 1),
                                    laCode: this.agvInfo.laCode,
                                    fcCode: localStorage.getItem("fcCode") || "",
                                    whCode: localStorage.getItem("whCode") || "",
                                    distrType: "10",
                                    person: localStorage.getItem("user") || "",
                                    personNumber: localStorage.getItem("empNumber") || null,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                    this.logRemarks = "stockProduceMat：生产叫料确认AGV配送成功";
                                    this.closeDailog();
                                } else {
                                    this.$message({
                                        message: resp.message,
                                        type: "error",
                                    });
                                    this.logRemarks = "stockProduceMat：生产叫料确认AGV配送失败";
                                }
                                this.agvDistributions = false;
                                this.logContent = "pmIds：" + this.agvInfo.pmIds + "laCode：" +  this.agvInfo.laCode;
                                this.systemLog();
                            })
                            .catch((error) => {
                                this.agvDistributions = false;
                                this.$message({
                                    message: "操作失败",
                                    type: "error",
                                });
                            });
                    })
                    .catch(() => {
                        this.agvDistributions = false;
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },

            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    whCode: this.mainSearch.whCode || null,
                    fcCode: this.mainSearch.fcCode || null,
                    // person: this.mainSearch.person || null,
                    distrType: this.mainSearch.distrType || null,
                    distrWay: this.mainSearch.distrWay || null,
                    operaCode: this.mainSearch.pmCode || null, // 生产叫料编号
                    opCode: this.mainSearch.opCode || null, // 生产工单编号
                    matCode: this.mainSearch.matCode || null, // 物料编号
                    boxBarCode: this.mainSearch.boxBarCode || null, //箱号
                    beginTime: this.mainSearch.date ? this.mainSearch.date[0] : null, // 开始时间
                    endTime: this.mainSearch.date ? this.mainSearch.date[1] : null, // 结束时间
                    pageNum: 1,
                    pageSize: 999999,
                };
                this.$http
                    .request({
                        url: "/api/stockPickDetail/getStockPickDetailData",
                        method: "GET",
                        params: paramsObj,
                    })
                    .then((resp) => {
                        resp.status == 100 ?
                            this.downLoad(resp.data.list || []) :
                            this.$notify.error({
                                message: "查询失败",
                            });
                    });
            },
            downLoad(list) {
                import("@/libs/Export2Excel").then((excel) => {
                    list.forEach(function(c) {
                        if (c.distrType == "10") {
                            c["distrType"] = "待配送";
                        } else if (c.distrType == "20") {
                            c["distrType"] = "配送中";
                        } else if (c.distrType == "30") {
                            c["distrType"] = "配送完成";
                        }

                        if (c.operaType == "10") {
                            c["operaType"] = "生产叫料";
                        } else if (c.operaType == "20") {
                            c["operaType"] = "间材叫料";
                        } else if (c.operaType == "30") {
                            c["operaType"] = "采购退货";
                        } else if (c.operaType == "40") {
                            c["operaType"] = "移库";
                        }

                        if (c.distrWay == "10") {
                            c["distrWay"] = "AGV配送";
                        } else if (c.distrWay == "20") {
                            c["distrWay"] = "人工配送";
                        }
                    });
                    const tHeader = [
                        "通道编号",
                        "物料编号",
                        "物料描述",
                        "物料数量",
                        "实际库位",
                        "包装箱号",
                        "操作编号",
                        "生产工单",
                        "需求类型",
                        "状态",
                        "配送人",
                        "配送方式",
                        "接单时间",
                        "拣配完成",
                        "配送开始时间",
                        "配送结束时间",
                        "创建时间",
                        "更新时间",
                    ];
                    const filterVal = [
                        "whCode",
                        "matCode",
                        "matName",
                        "matQuan",
                        "lcCodeReal",
                        "boxBarcode",
                        "operaCode",
                        "opCode",
                        "operaType",
                        "distrType",
                        "userName",
                        "distrWay",
                        "receiveTime",
                        "pickTime",
                        "distributionStartTime",
                        "distributionEndTime",
                        "createTime",
                        "updateTime",
                    ];
                    const data = this.formatJson(filterVal, list);
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: "物料配送",
                    });
                    this.logContent = "导出";
                    this.logRemarks = "stock_produce_mat：导出物料配送记录";
                    this.systemLog();
                    this.downloadLoading = false;
                });
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map((v) => filterVal.map((j) => v[j]));
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "物料配送",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        showLoading: true,
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
            getLcCodeAllByWhCode(whCode) {
                this.$http
                    .request({
                        url: "/api/sysLineRouter/getLcCodeAllByWhCode",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            whCode: whCode || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.sysLineRouterList = resp.data || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
        },
        activated(){
            // 从页面跳转传值
            let pmCode = this.$route.query.pmCode;
			if (pmCode) {
				this.mainSearch.pmCode = pmCode;
			} else {
				this.getTableData();
			}
            this.getWarehouse();
			/* 获取首页的数据 */
            //this.getLcCodeAllByWhCode();
        },
    };
</script>

<style scoped>
</style>